type DisplayByDateTimeOptions = {
  requestDate: string
  now?: Date
  cutoffHour?: number
  cutoffMinute?: number
}

const parseLocalDate = (dateOnly: string): Date => {
  // Parse yyyy-MM-dd as local time to avoid UTC parsing differences.
  const [year, month, day] = dateOnly.split('-').map(Number)
  return new Date(year, month - 1, day, 0, 0, 0, 0)
}

export const canDisplayByDateTime = ({
  requestDate,
  now = new Date(),
  cutoffHour,
  cutoffMinute = 0,
}: DisplayByDateTimeOptions): boolean => {
  const requestDateTime = parseLocalDate(requestDate)

  // Hidden until request date arrives.
  if (requestDateTime > now) return false

  // When no cutoff is provided, this behaves as date-only display control.
  if (cutoffHour === undefined) return true

  // Apply optional cutoff time on the request date.
  const displayStartAt = new Date(requestDateTime)
  displayStartAt.setHours(cutoffHour, cutoffMinute, 0, 0)
  return now >= displayStartAt
}
